import { useEffect, useRef } from 'react';
import useThemeStore, { getSystemTheme } from 'stores/themeStore';
import type { UserSelectedTheme } from 'stores/themeStore';

export type ThemeCardSize = 'sm' | 'md' | 'lg';

const useThemeSetting = () => {
  const { userSelectedTheme, setUserSelectedTheme } = useThemeStore();
  const initialThemeRef = useRef<UserSelectedTheme>(useThemeStore.getState().userSelectedTheme); // 마운트 시 초기 테마 저장
  const isConfirmedRef = useRef(false); // 확인 버튼을 누르지 않았는지 확인

  // 언마운트 시 확인 버튼을 누르지 않았으면 원래 테마로 복원
  useEffect(() => {
    const initialTheme = initialThemeRef.current;
    return () => {
      if (!isConfirmedRef.current) {
        setUserSelectedTheme(initialTheme);
      }
    };
  }, [setUserSelectedTheme]);

  const lightThemeCardSize: ThemeCardSize = userSelectedTheme === 'light' ? 'lg' : userSelectedTheme === 'dark' ? 'sm' : 'md';
  const darkThemeCardSize: ThemeCardSize = userSelectedTheme === 'dark' ? 'lg' : userSelectedTheme === 'light' ? 'sm' : 'md';

  const handleThemeCardClick = (theme: UserSelectedTheme) => {
    setUserSelectedTheme(theme);
  };

  const handleSwitchChange = () => {
    setUserSelectedTheme(userSelectedTheme === 'system' ? getSystemTheme() : 'system');
  };

  const handleConfirm = () => {
    isConfirmedRef.current = true;
  };

  return {
    userSelectedTheme,
    lightThemeCardSize,
    darkThemeCardSize,
    handleThemeCardClick,
    handleSwitchChange,
    handleConfirm,
  };
};

export default useThemeSetting;
